import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-invisble.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const InVisibleIcon = createSvgIcon(<Icon />, 'InVisibleIcon');
